function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8076 18.8066C63.6519 15.4004 63.1108 13.0742 62.3198 11.0391C61.5166 8.90381 60.2568 6.96973 58.6289 5.37109C57.0308 3.74316 55.0962 2.48291 52.9609 1.6792C50.9253 0.888672 48.5996 0.348145 45.1934 0.193359C41.7808 0.0371094 40.6904 0 32 0C23.3096 0 22.2192 0.0371094 18.8066 0.192383C15.4004 0.348145 13.0747 0.88916 11.0391 1.68018C8.90381 2.4834 6.96973 3.74316 5.37109 5.37109C3.74316 6.96924 2.48291 8.90332 1.6792 11.0386C0.888672 13.0742 0.348145 15.4004 0.193359 18.8062C0.0371094 22.2192 0 23.3091 0 31.9995C0 40.6904 0.0371094 41.7808 0.193359 45.1934C0.348633 48.5991 0.889648 50.9253 1.68066 52.9609C2.48389 55.0957 3.74365 57.0303 5.37158 58.6284C6.96973 60.2563 8.9043 61.5161 11.0396 62.3193C13.0747 63.1108 15.4009 63.6514 18.8071 63.8071C22.2202 63.9629 23.3101 63.9995 32.0005 63.9995C40.6909 63.9995 41.7812 63.9629 45.1938 63.8071C48.6001 63.6514 50.9258 63.1108 52.9614 62.3193C57.2598 60.6572 60.6577 57.2593 62.3198 52.9609C63.1113 50.9253 63.6519 48.5991 63.8076 45.1934C63.9629 41.7803 64 40.6904 64 32C64 23.3091 63.9629 22.2192 63.8076 18.8066ZM58.0474 44.9312C57.9053 48.0513 57.3838 49.7456 56.9458 50.873C55.8691 53.6641 53.6636 55.8696 50.8726 56.9463C49.7451 57.3843 48.0508 57.9058 44.9307 58.0479C41.5571 58.2021 40.5449 58.2344 32 58.2344C23.4546 58.2344 22.4429 58.2021 19.0688 58.0479C15.9492 57.9058 14.2549 57.3843 13.127 56.9463C11.7373 56.4331 10.48 55.6152 9.44775 54.5522C8.38477 53.52 7.56689 52.2632 7.05371 50.873C6.61572 49.7456 6.09424 48.0513 5.95215 44.9312C5.79834 41.5571 5.76562 40.5449 5.76562 32.0005C5.76562 23.4556 5.79834 22.4438 5.95215 19.0693C6.09473 15.9492 6.61572 14.2549 7.05371 13.1274C7.56689 11.7373 8.38525 10.48 9.44775 9.44775C10.48 8.38477 11.7373 7.56689 13.1274 7.0542C14.2549 6.61572 15.9492 6.09473 19.0693 5.95215C22.4434 5.79834 23.4556 5.76562 32 5.76562H31.9995C40.5439 5.76562 41.5562 5.79834 44.9307 5.95264C48.0508 6.09473 49.7446 6.61621 50.8726 7.0542C52.2622 7.56738 53.5195 8.38525 54.5518 9.44775C55.6147 10.48 56.4326 11.7373 56.9453 13.1274C57.3838 14.2549 57.9053 15.9492 58.0474 19.0693C58.2012 22.4434 58.2339 23.4556 58.2339 32C58.2339 40.5449 58.2017 41.5566 58.0474 44.9312Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9995 15.5674C22.9243 15.5674 15.5674 22.9248 15.5674 32C15.5674 41.0752 22.9243 48.4321 31.9995 48.4321C41.0752 48.4321 48.4321 41.0752 48.4321 32C48.4321 22.9248 41.0752 15.5674 31.9995 15.5674ZM31.9995 42.6665C26.1089 42.666 21.333 37.8906 21.3335 31.9995C21.3335 26.1089 26.1089 21.333 32 21.333C37.8911 21.3335 42.6665 26.1089 42.6665 31.9995C42.6665 37.8906 37.8906 42.6665 31.9995 42.6665Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9214 14.9185C52.9214 17.0391 51.2021 18.7583 49.0815 18.7583C46.9604 18.7583 45.2412 17.0391 45.2412 14.9185C45.2412 12.7974 46.9604 11.0781 49.0815 11.0781C51.2021 11.0781 52.9214 12.7974 52.9214 14.9185Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 5.37077,
  y1: 58.6287,
  x2: 58.6292,
  y2: 5.37025,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#FF0100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D800B9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 20.3804,
  y1: 43.6192,
  x2: 43.6192,
  y2: 20.3804,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6400"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#FF0100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FD0056"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 46.3661,
  y1: 17.6335,
  x2: 51.7966,
  y2: 12.203,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F30072"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E50097"
})));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.01fd6834.svg";
export { ForwardRef as ReactComponent };